export default {
	wrapper: {
		marginTop: '-40px',
		'& .rbc-event': {
			fontSize: '10px',
		},
		'& .rbc-allday-cell': {
			'& .rbc-row-content': {
				minHeight: '0',
			},
			'& .day-label': {
				display: 'none',
			},
			'& .preview-label': {
				display: 'none',
			},
		},
		'& .rbc-day-slot .rbc-event': {
			borderBottom: '1px solid #fff',

			'& .preview-label': {
				display: 'none',
			}
		},
		'& .rbc-event-label': {
			display: 'none',
		},
		'& .rbc-event-content div': {
			overflow: 'hidden',
			textOverflow: 'ellipsis',
		},
		'& .rbc-month-row': {
			'& .day-label': {
				display: 'none',
			},
			'& .all-day-label': {
				display: 'none',
			},
		},
		'& .rbc-time-content': {
			'& .all-day-label': {
				display: 'none',
			},
		},
	},
}
